<template>
  <div id="app">
    <quiz-header></quiz-header>
    <main>
      <div class="container">
        <quiz-start v-if="isStart" @set="startQuiz"></quiz-start>
        <quiz-result
          v-if="isResult"
          @reset-quiz="resetQuiz"
          :calc_result="calc_result"
          :results_array="results_array"
        ></quiz-result>

        <template v-if="isQuiz || isResult">
          <div
            v-for="(data,i) in questions.data"
            class="quiz-layout"
            :class="[{isResult : isResult} , !result[i] && isResult? 'is-noncorrect': ''] "
            v-if="i === currentQuestion || isResult"
            :key="data.id"
          >
            <div class="quiz-question">
              <div class="quiz-question-number">
                <div class="quiz-number">Q{{ i+1 }}</div>
              </div>
              <div class="quiz-question-text">
                <div v-html="data.problem"></div>
              </div>
              <div v-if="data.problemImage" class="quiz-question-image">
                <p class="text-center">
                  <img :src="data.problemImage" alt class="img-fluid" />
                </p>
              </div>
            </div>
            <div v-if="data.type === 'radio'" class="row quiz-choice">
              <div v-for="(ans,index) in data.answer" class="col-md-6 my-2">
                <input
                  type="radio"
                  :id="'answer'+index"
                  v-model="checkedChoices[i][0]"
                  :name="'question'+i"
                  :value="ans"
                  :disabled="isResult"
                />
                <label :for="'answer'+index" v-bind:class="correctClass(i, ans)">{{ans}}</label>
              </div>
            </div>
            <div v-if="data.type === 'checkbox'" class="row quiz-choice">
              <div v-for="(ans,index) in data.answer" class="col-md-6 my-2">
                <input
                  type="checkbox"
                  :id="'answer'+index"
                  v-model="checkedChoices[i]"
                  :name="'question'+i"
                  :value="ans"
                  :disabled="isResult"
                />
                <label :for="'answer'+index" v-bind:class="correctClass(i, ans)">{{ans}}</label>
              </div>
            </div>
            <div v-if="isResult" class="area-result">
              <div class="area-result-mark">
                <p v-if="result[i]" class="result-correct">
                  <font-awesome-icon icon="genderless" size="3x" />正解
                </p>
                <p v-else class="result-incorrect">
                  <font-awesome-icon icon="times" size="2x" />不正解
                </p>
              </div>
              <div v-if="data.answer_text" class="area-result-text">
                <p v-if="data.answer_text">解説</p>
                <vue-simple-markdown :source="data.answer_text"></vue-simple-markdown>
                <img v-if="data.answerImage" class="img-fluid" :src="data.answerImage" />
              </div>
            </div>
            <div v-else class="text-center py-4">
              <b-button @click="nextQuiz" class="mx-auto btn-click">
                回答して次へ
                <font-awesome-icon icon="arrow-circle-right" />
              </b-button>
            </div>
          </div>
          <progress-bar v-if="isQuiz" class="mt-5" :current-question="currentQuestion"></progress-bar>
        </template>
        <div class="my-4" v-if="isResult">
          <b-button @click="resetQuiz" class="mx-auto btn-click">
            もう一回やる
            <font-awesome-icon icon="undo" />
          </b-button>
        </div>
        <quiz-campaign v-if="isResult" :results_array="results_array"></quiz-campaign>
        <p class="text-right bg-accent">
          <img src="img/bg-accent.png" alt class="img-fluid" />
        </p>
      </div>
    </main>
    <footer class="px-3 text-center">
      <quiz-footer></quiz-footer>
    </footer>
  </div>
</template>

<script>
//import Quiz from './components/Quiz'
import axios from "axios";

//コンポーネント
import QuizHeader from "./components/QuizHeader";
import QuizFooter from "./components/QuizFooter";
import ProgressBar from "./components/ProgressBar";
import QuizStart from "./components/start";
import QuizResult from "./components/result";
import QuizCampaign from "./components/QuizCampaign";

const IS_START = "IS_START";
const IS_QUIZ = "IS_QUIZ";
const IS_RESULT = "IS_RESULT";

export default {
  name: "app",
  components: {
    QuizHeader,
    QuizFooter,
    ProgressBar,
    QuizStart,
    QuizResult,
    QuizCampaign
  },
  data() {
    return {
      questions: [],
      checkedChoices: [[0]],
      result: [],
      calc_result: 0,
      currentStage: IS_START,
      currentQuestion: 0,
      results_array: {},
      results_rank: 0,
      results_sns_text: ""
    };
  },
  computed: {
    isStart: function() {
      return this.currentStage === IS_START;
    },
    isQuiz: function() {
      return this.currentStage === IS_QUIZ;
    },
    isResult: function() {
      return this.currentStage === IS_RESULT;
    }
  },
  created() {
    axios.get("./data/quiz.json").then(response => {
      this.questions = response.data;
    });

    let uri = window.location.href.split("?");
    if (uri.length == 2) {
      let vars = uri[1].split("&");
      let getVars = {};
      let tmp = "";
      vars.forEach(function(v) {
        tmp = v.split("=");
        if (tmp.length == 2) getVars[tmp[0]] = tmp[1];
      });
    }
  },
  methods: {
    startQuiz: function() {
      this.currentStage = IS_QUIZ;
      window.scrollTo(0, 0);
    },
    nextQuiz: function() {
      var index = this.currentQuestion;
      var q = this.questions.data[index];
      if (
        this.checkedChoices[index][0] == 0 ||
        this.checkedChoices[index][0] == null
      )
        return false;
      this.result[index] = compareArr(q.correct, this.checkedChoices[index]);
      this.calc_result += this.result[index];
      this.currentQuestion++;
      if (this.currentQuestion === this.questions.data.length) {
        this.aggregate();
        this.currentStage = IS_RESULT;
      } else {
        this.checkedChoices[this.currentQuestion] = new Array();
      }
      window.scrollTo(0, 0);
    },
    resetQuiz: function() {
      this.checkedChoices = [[0]];
      this.currentStage = IS_START;
      this.currentQuestion = 0;
      this.calc_result = 0;
    },
    correctClass: function(index, answer) {
      if (this.isResult) {
        var correct = this.questions.data[index].correct;
        for (var i = 0; i < correct.length; i++) {
          if (answer === correct[i]) return "correct";
        }
      }
    },
    aggregate: function() {
      var result_per = (this.calc_result / this.questions.data.length) * 100;
      for (var i = 0; i < this.questions.rank.length; i++) {
        if (result_per >= this.questions.rank[i].percent) {
          this.results_rank = i;
          this.results_array = this.questions.rank[i];
        } else {
          return;
        }
      }
    }
  }
};

// Array比較function、配列のオーダーに関係なく同じ内容を含む場合はtrueを、そうでない場合はfalseを返す
function compareArr(arr1, arr2) {
  // 解答数と回答数が異なる場合false
  if (arr1.length !== arr2.length) {
    return 0;
  }

  arr1 = arr1.sort();
  arr2 = arr2.sort();

  // 解答と回答の内容が異なる場合false
  for (var i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return 0;
    }
  }
  return 1;
}
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Noto+Sans+JP");
html {
  @media (min-width: 768px) {
    font-size: 18px;
  }
}
body {
  color: #1f9fb2;
  font-family: -apple-system, "Noto Sans JP", メイリオ, Meiryo,
    "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "游ゴシック Medium",
    游ゴシック体, "Yu Gothic Medium", YuGothic, sans-serif;
}
.container {
  padding-right: 5px;
  padding-left: 5px;
  @media (min-width: 576px) {
    padding-right: 15px;
    padding-left: 15px;
  }
}
.row {
  margin-right: -5px;
  margin-left: -5px;
  @media (min-width: 576px) {
    margin-right: -15px;
    margin-left: -15px;
  }
}
.h1,
h1 {
  font-size: 2rem;
  @media (min-width: 768px) {
    font-size: 2.5rem;
  }
}
.h2,
h2 {
  font-size: 1.8rem;
  @media (min-width: 768px) {
    font-size: 2rem;
  }
}

@media (max-width: 767px) {
  .container {
    max-width: 100%;
  }
}
main {
  background: url("static/bg_dotyellow.png") repeat 0 0;
  padding: 1rem 0 0;
  text-align: center;
  @media (min-width: 992px) {
    padding: 2rem 5rem 0;
  }
}

.quiz-layout {
  padding: 2rem 1rem;
  text-align: left;
  background: rgba(255, 255, 255, 0.6);
  margin: 0.5rem 0;
  @media (min-width: 576px) {
    margin: 2rem 0;
  }
  @media (min-width: 768px) {
    padding: 2rem 3rem;
  }

  &.isResult {
    background: rgba(255, 255, 255, 0.6);
  }
}
.quiz-text {
  margin: 0 0 2rem;
}
.quiz-question {
  background: #fff;
  border-radius: 1rem;
  margin-bottom: 1rem;
  position: relative;
  padding: 0.5rem 1rem 1rem;
  @media (min-width: 576px) {
    display: flex;
    padding: 2rem;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
  }
  @media (min-width: 768px) {
  }
  &:before {
    content: "";
    position: absolute;
  }

  .quiz-number {
    font-size: 1.5rem;
    border-radius: 50%;
    background: #1f9fb2;
    color: #fff;
    width: 3rem;
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    line-height: 1;
    font-family: "Franklin Gothic Medium";
    margin: 0 0 0.5rem;
    @media (min-width: 576px) {
      margin: 0;
    }
    @media (min-width: 768px) {
      margin-bottom: 0;
      font-size: 40px;
      width: 80px;
      height: 80px;
    }
  }

  .quiz-question-text {
    flex-basis: auto;
    line-height: 1.7;
    strong {
      color: red;
      background: linear-gradient(transparent 70%, #fedee7 70%);
      padding: 1px 3px;
    }
    @media (min-width: 576px) {
      padding-left: 1em;
      width: calc(100% - 80px);
    }
    @media (min-width: 768px) {
    }
  }
  .quiz-question-image {
    margin-top: 1rem;
    flex: auto;
    img {
      border: 1px solid #d1d1d1;
      @media (min-width: 576px) {
        max-width: 90%;
      }
      @media (min-width: 768px) {
        max-width: 80%;
      }
    }
  }
}

input[type="radio"],
input[type="checkbox"] {
  display: none;
  position: relative;
  & + label {
    line-height: 1.6em;
    display: block;
    padding: 0.5rem;
    margin: 0;
    font-size: 16px;
    cursor: pointer;
    padding-left: 2.5em;
    height: 100%;
    align-items: center;
    text-align: left;
    color: #000;
    position: relative;
    img {
      display: block;
      margin: 0.5rem;
    }
    &:before {
      content: "";
      width: 1.6em;
      height: 1.6em;
      position: absolute;
      top: inherit;
      left: 0.5em;
      margin-right: 0.5em;
      box-shadow: inset 2.487px 1.678px 2px 0px rgba(0, 0, 0, 0.35);
      background: #fff;
    }
    &.correct {
      border: 2px solid #1f9fb2;
    }
  }
  &:checked {
    & + label {
      &:before {
        border-color: #1f9fb2;
      }
    }
  }
  &:disabled {
    & + label {
      cursor: default;
    }
  }
}
input[type="radio"] {
  & + label {
    &:before {
      border-radius: 100%;
    }
  }
  &:checked {
    & + label {
      &:after {
        content: "";
        width: 0;
        height: 0;
        border: 0.5em solid #1f9fb2;
        position: absolute;
        top: 0.9em;
        left: 0.9em;
        line-height: 1;
        border-radius: 100%;
      }
    }
  }
}
input[type="checkbox"] {
  &:checked {
    & + label {
      &:after {
        content: "";
        width: 1em;
        height: 0.6em;
        border: 4px solid #1f9fb2;
        position: absolute;
        top: inherit;
        left: 0.9em;
        top: 0.9em;
        border-right: 0;
        border-top: 0;

        transform: rotate(-55deg);
      }
    }
  }
}
.area-result {
  background: #fff;
  border-radius: 1rem;
  padding: 1rem;
  @media (min-width: 576px) {
    padding: 2rem;
  }
  @media (min-width: 768px) {
    display: flex;
    align-items: center;
  }
  .area-result-mark {
    color: #1f9fb2;
    font-size: 2rem;
    flex: 0 0 200px;
    .result-correct,
    .result-incorrect {
      display: flex;
      align-items: center;
      svg {
        margin-right: 1rem;
        margin-bottom: 3px;
      }
    }
    .result-correct {
    }
    .result-incorrect {
      color: #ff4c7a;
    }
  }
  .area-result-text {
    border-top: 1px solid #bfbfbf;
    padding-top: 2rem;
    flex: 1;
    min-width: 0;
    @media (min-width: 768px) {
      border-top: none;
      padding-top: 0;
      border-left: 1px solid #bfbfbf;
      padding-left: 2rem;
    }
  }
}

.is-noncorrect .correct {
  border-color: #ff4c7a !important;
  background: #e3e3e3 !important;
}

.markdown-body {
  font-family: -apple-system, メイリオ, Meiryo, "ヒラギノ角ゴ Pro",
    "Hiragino Kaku Gothic Pro", "游ゴシック Medium", 游ゴシック体,
    "Yu Gothic Medium", YuGothic, sans-serif;
  color: #3a8286;
}

.btn-click {
  background: #1f9fb2;
  color: #fff;
  border: none;
  border-radius: 0.8em;
  padding: 0.5em 2em;
  font-size: 1.3rem;
  font-weight: bold;
  box-shadow: 0px 0px 7.2px 2.8px rgba(0, 0, 0, 0.15);
  @media (min-width: 768px) {
    font-size: 1.6rem;
  }
}

.bg-accent {
  img {
    max-width: 150px;
    @media (min-width: 576px) {
      max-width: 300px;
    }
    @media (min-width: 768px) {
      max-width: 450px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue